import "../common";
import "../components/FAQEntry";
import "../components/hotel-list/ClassificationFilter";
import "../components/hotel-list/FilterDialogButton";
import "../components/hotel-list/ListHeaderCounter";
import "../components/hotel-list/ProgressBar";
import "../components/hotel-list/RecentlyUsedFilters";
import "../components/hotel-list/ResetFilters";
import "../components/hotel-list/Deals";
import "../components/hotel-list/sorting/SelectorMobile";
import "../components/hotel-list/sorting/SelectorDesktop";
import "../components/hotel-list/PriceFilterSection";
import "../components/hotel-list/BoardFilter";
import "../components/hotel-list/ScoreFilter";
import "../components/hotel-list/Pagination";
import "../components/tracker/ImpressionInteractionTracker";
import {
	store,
	ACTION_PARSE_HASH,
	ACTION_UPDATE_TRAVEL_DATA,
	ACTION_SET_TOGGLE_FILTER,
	ACTION_REMOVE_TOGGLE_FILTER,
} from "../components/hotel-list/DataStore";
import "../tracker/PerformanceHotelList";

import "../components/hotel-list/HotelList";

// Ads
import * as Stroer from "../components/ads/stroer/Ads";
import "../components/ads/stroer/BannerForList";
import "../components/ads/BookingBanner";
import "../components/ads/google-adsense/ImmediatelyBlock";
import "../components/ads/optimonk/hotel-list-loader";
import "../components/FooterItemLinkNewsletter";

Stroer.setZone("search");

store.dispatch(ACTION_PARSE_HASH, window.location.hash);
window.onpopstate = () =>
	store.dispatch(ACTION_PARSE_HASH, window.location.hash);

import { onChangeAny, travelData } from "../state/travelData";
onChangeAny(() => store.dispatch(ACTION_UPDATE_TRAVEL_DATA, travelData));

import { data } from "../../shared/state/payload";
import { add as addToHistory } from "../state/history";
import { trackPageVisit } from "@escapio/portal/tracker/Pinterest";
import { registerButtonHandler } from "@escapio/portal/components/map/button-handling";
import { registerMultiToggleFilter } from "@escapio/portal/components/MultiToggleFilter";
import { categoryFilters } from "@escapio/portal/state/hotel-list/get-category-fitlers";

registerMultiToggleFilter(
	store,
	categoryFilters,
	ACTION_SET_TOGGLE_FILTER,
	ACTION_REMOVE_TOGGLE_FILTER,
	data.preselectedHotelType,
);

addToHistory({
	item_id: data.trackingId,
	name: data.articleTitle,
	label: data.articleTitle,
	link: location.pathname,
	type: data.page_search_type,
	type_label: data.page_search_type_label,
	geo_paths: data.geo_path
		? Object.entries(data.geo_path)
				.map(([, { title }]) => title)
				.slice(1)
		: null,
	hotels_number: data.hotel_list.filter(hotel => hotel.distance === -1).length,
	is_alternative: false,
});
trackPageVisit(data.trackingId, data.articleTitle);

import { ListMapDialog } from "../components/map/ListMapDialog";

registerButtonHandler(ListMapDialog);
